// ** Bundle Support

let CartBundler = function(){


    this.init = function(){

        let Bundles = this.FindBundles();
        this.removeCache();
        this.BindBundles(Bundles);
        
    }

    this.BindBundles = function(bundles){
        bundles.forEach(id => {
            let $bundle_products = $('[bundle-id="'+id+'"]');
            console.log($bundle_products.length)


            let Total_price = 0;
            $bundle_products.each(function(){
                let price = $(this).attr('total-price');
                Total_price += parseInt(price);
            })



            let formattedPrice = Shopify.formatMoney(Total_price, "£{{amount}}");

            let bundleSummary = `<div class="BundleSummary">
            <div class="BundleSummary--remove"><a href="#" class="cart__remove-bundle" data-bundle-id="${id}">Remove</a></div>
            <div class="BundleSummary--price">Total: ${formattedPrice}</div>
            </div>`;
            let bundleTitle = `<div class="BundleTitle">
                Pick and Mix Bundle
            </div>`;

            $($bundle_products[$bundle_products.length-1]).after(bundleSummary)
            $($bundle_products[0]).before(bundleTitle)
             // Registers each cart bundle item's remove button
             

        });
    }

    this.removeCache = function() {
        $('.BundleSummary').remove();
        $('.BundleTitle').remove();
    }


    this.FindBundles = function(){
        let Bundles = [];
        let $cache = {
            bundles:  $('[bundle-id]')
        },
        last_bundle_id;

        
        $cache.bundles.each(function(){
            let self = $(this),
                BundleID = $(self).attr('bundle-id');


            if (last_bundle_id != BundleID) Bundles.push(BundleID);
            last_bundle_id = BundleID;

        });


        return Bundles;
    }
}


window.CartBundler = new CartBundler();


$(function(){

    window.CartBundler.init();

    
    $(document).on('cart.ready', function(event, cart) {
        window.CartBundler.init();
    });
    
    $(this).on('cart.requestComplete', function(event, cart) {
        // Event handling here.
        $('.cart-count').html((cart.item_count > 9 ? "" : "0") + cart.item_count);
        window.CartBundler.init();
        if (!modalOpen) openModal();
    });






})
